export const styles = {
  tabsWrap: {
    display: 'flex',
    borderRadius: 12,
    border: '1px solid #E5E7EB',
    overflow: 'hidden',
    marginBottom: 14,
    background: '#F9FAFB',
  },
  tabBtn: (active, withDivider) => ({
    flex: 1,
    height: 42,
    border: 'none',
    background: active ? '#FFFFFF' : '#F9FAFB',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    fontSize: 14,
    fontWeight: 600,
    color: '#111827',
    ...(withDivider ? { borderLeft: '1px solid #E5E7EB' } : {}),
  }),
  sectionLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },

  bigBox: {
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    padding: 18,
    background: '#FFFFFF',
  },
  actionItem: (active) => ({
    width: '100%',
    textAlign: 'left',
    borderRadius: 12,
    border: active ? '2px solid #1C4B75' : '1px solid #E5E7EB',
    padding: 16,
    background: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  }),
  actionIconBox: (variant) => ({
    width: 38,
    height: 38,
    borderRadius: 12,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...(variant === 'primary' ? { background: '#EEF2FF' } : {}),
  }),
  contentCol: { flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 10 },
  textsCol: { minWidth: 0, display: 'flex', flexDirection: 'column' },
  actionTitle: { fontSize: 14, fontWeight: 700, color: '#111827', lineHeight: '18px' },
  actionDesc: { fontSize: 13, fontWeight: 400, color: '#6B7280', lineHeight: '16px', marginTop: 2 },
  badge: {
    padding: '2px 10px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    background: '#EFF6FF',
    border: '1px solid #93C5FD',
    color: '#1C4B75',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
  },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 18 },
  linkBlockedNote: {
    marginBottom: 14,
    padding: '8px 12px',
    background: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    textAlign: 'center',
  },
  maintenanceCard: {
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    marginTop: 16,
  },
  maintenanceTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  maintenanceIconBox: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  maintenanceDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#D1D5DB',
    margin: '10px 0 14px',
  },
  maintenanceOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  maintenanceOption: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    padding: 12,
    borderRadius: 12,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
  },
  maintenanceOptionText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  maintenanceOptionTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: '#111827',
    lineHeight: '18px',
  },
  maintenanceOptionDesc: {
    fontSize: 12,
    fontWeight: 400,
    color: '#6B7280',
    lineHeight: '16px',
  },
  maintenanceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 0',
    marginTop: 6,
  },
  maintenanceLeftIcon: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  maintenanceRowTexts: {
    flex: 1,
    minWidth: 0,
  },
  maintenanceRowTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: '#111827',
    lineHeight: '18px',
  },
  maintenanceRowDesc: {
    fontSize: 12,
    fontWeight: 400,
    color: '#6B7280',
    lineHeight: '16px',
    marginTop: 2,
  },
  maintenanceRightControl: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  numberInput: {
    width: 86,
    minWidth: 86,
    height: 32,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    padding: '0 10px',
    textAlign: 'center',
    fontSize: 13,
    outline: 'none',
    background: '#FFFFFF',
    color: '#111827',
  },
  stepBtn: {
    width: 28,
    height: 28,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: '26px',
    color: '#111827',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
  },
};
